// extracted by mini-css-extract-plugin
export default {"title":"A9HaVJ","description":"EUPaDO","stats":"zzKkJu","instructions":"ZCiDSJ"};